import PrecisionManufacturing from '@mui/icons-material/PrecisionManufacturing';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import BusinessIcon from '@mui/icons-material/Business';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import FlightIcon from '@mui/icons-material/Flight';
import ExpandIcon from '@mui/icons-material/Expand';
import SyncIcon from '@mui/icons-material/Sync';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import ScheduleIcon from '@mui/icons-material/Schedule';
import InsightsIcon from '@mui/icons-material/Insights';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EngineeringIcon from '@mui/icons-material/Engineering';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';


// Import other icons as needed

export const getIcon = (iconType: string) => {
    switch (iconType) {
        case 'manufacturing':
            return <PrecisionManufacturing sx={{ scale: '1.4' }}/>;
        case 'warehouse':
            return <WarehouseIcon sx={{ scale: '1.4' }}/>;
        case 'business':
            return <BusinessIcon sx={{ scale: '1.4' }}/>;
        case 'award':
            return <EmojiEventsIcon sx={{scale: '1.4'}}/>
        case 'thermostat':
            return <ThermostatIcon sx={{scale: '1.4'}}/>;
        case 'airplane':
            return <FlightIcon sx={{scale: '1.4'}}/>;
        case 'expand':
            return <ExpandIcon sx={{scale: '1.4'}}/>;
        case 'sync':
            return <SyncIcon sx={{scale: '1.4'}}/>;
        case 'call-split':
            return <CallSplitIcon sx={{scale: '1.4'}}/>;
        case 'schedule':
            return <ScheduleIcon sx={{scale: '1.4'}}/>;
        case 'insights':
            return <InsightsIcon sx={{scale: '1.4'}}/>;
        case 'back-arrow':
            return <ArrowBackIcon sx={{scale: '1.4'}}/>;
        case 'front-arrow':
            return <ArrowForwardIcon sx={{scale: '1.4'}}/>;
        case 'Engineering':
            return <EngineeringIcon sx={{scale: '1.4'}}/>;
        case 'PrecisionManufacturing':
            return <PrecisionManufacturing sx={{scale: '1.4'}}/>;
        case 'Lightbulb':
            return <LightbulbIcon sx={{scale: '1.4'}}/>;
        case 'SupportAgent':
            return <SupportAgentIcon sx={{scale: '1.4'}}/>;
        default:
            return <PrecisionManufacturing sx={{ scale: '1.4' }} />;
    }
};
